export default function authHeader() {
  const user = localStorage.getItem('token');

  if (user != null) {
    return { Authorization: 'Bearer ' + user };
  } else {
    return {};
  }
}